module.exports = __webpack_public_path__ + "static/media/tt.26787933.svg";